export default {
    "progressBar": false,
    "positionClass": "toast-top-right",
    "preventDuplicates": false,
    "showDuration": "350",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "closeButton": true,
    "debug": true
}


// WEBPACK FOOTER //
// ./src/common/toast/toastr-config.js